<div class="row col-12 p-0 m-0 main-page-section">
    <!-- <div class="p-0">
              <app-side-nav [item]="meetingNav"></app-side-nav>
          </div> -->
    <div class="col-12 p-0 employee-section">
        <!-- <app-header></app-header> -->
        <div class="col-height">

            <div>
                <div class="breadcrumbs-section pl-2 ml-5">
                    <span class="prev-page pr-2 prev" routerLink="/overview">Home</span>
                    <img src="../../assets/images/seperator.png">
                    <span class="prev-page pr-2 pl-2 prev" routerLink="/facility">Facilities</span>
                    <img src="../../assets/images/seperator.png">
                    <span class="prev-page pr-2 pl-2 prev" routerLink="/facility">Manage Facility</span>
                    <img src="../../assets/images/seperator.png">
                    <span class="curr-page pl-2 breadcrumbs-section-font current">{{facilityName}}</span>
                </div>

                <div class="history-layout">
                    <div class="row pb-3">
                        <div class="col-9">
                            <h1>{{facilityName}}</h1>
                        </div>
                        <div class="col-3"><button (click)="navigateToDetail()">View Facility Details</button></div>
                    </div>
                </div>


                <div class="col-12 d-flex justify-content-start row borders m-0 p-0 mb-2 ">
                    <div class="col-3 borders-right d-flex justify-content-start relative-content">
                        <div class="pt-3 pb-3" (clickOutside)="onClickedOutside($event)" [autoClose]="'outside'"
                            [ngbPopover]="popMeetingRooms" triggers="manual" #p1="ngbPopover"
                            (click)="openPopover(p1,0)" placement="bottom" popoverClass='dash-popover dashboard-popover'
                            class=" meeting-label center-align box-size pointer-link text-center meeting-room-head">
                            <div style="width: 100px;">Booking Status</div>
                            <img src="../../assets/images/Path.png" class="pr-3  access-point-arrow" loading="lazy" />
                            <div class="bold-font">{{BookingStatusText}}</div>
                            <div>
                                <ng-template #popMeetingRooms>
                                    <div class="dashboard-popover ">
                                        <div class="">
                                            <div class="">
                                                <div class="row pb-3 d-flex justify-content-start pointer-link"
                                                    [ngClass]="BookingStatusText==item.statusText?'bold-font ':'normal-font'"
                                                    *ngFor="let item of BookingStatus;let i=index"
                                                    (click)="setStatus(item)">
                                                    {{item.statusText}}
                                                    <div>
                                                        <img *ngIf="BookingStatusText==item.statusText"
                                                            class="pl-5 ml-4" src="/assets/images/tick.png">
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-template>
                            </div>
                        </div>
                    </div>

                    <div class="pt-3 pb-3 col-2 borders-right">
                        <span class="text pt-3" style=" position: absolute; margin-left: 31px;margin-top: -14px;">From
                            Date</span>
                        <input class="cal-icon all-hosts pt-3  pointer-link" (click)="d2.toggle()" [(ngModel)]="fDate"
                            ngbDatepicker #d2="ngbDatepicker" (dateSelect)="updateSelectedFromDate($event)">
                        <div class="meeting-sub-label from-date">{{formattedSelectedFromDate}}</div>
                    </div>
                    <div class="pt-3 pb-3 col-2 borders-right">
                        <span class="text pt-3" style=" position: absolute; margin-left: 31px;margin-top: -14px;">To
                            Date</span>
                        <input class="cal-icon all-hosts pt-3  pointer-link" (click)="d3.toggle()" [(ngModel)]="tDate"
                            ngbDatepicker #d3="ngbDatepicker" (dateSelect)="updateSelectedToDate($event)">
                        <div class="meeting-sub-label from-date">{{formattedSelectedToDate}}</div>
                    </div>
                    <div class="col-5"></div>
                </div>

                <empty-state *ngIf="FacilityBookedDetails?.length==0"></empty-state>

                <div *ngIf="FacilityBookedDetails?.length>0">
                    <div class="view-layout mt-5">

                        <!-- <div class="row pr-4">
                            <div class="col-10"></div>
                            <div class="col-2  d-flex justify-content-end">
                                <label class="check-container">
                                    <input type="checkbox" [checked]="selectAll" [(ngModel)]="selectAll"
                                        value="selectAll" (change)="toggleSelectAllSelection($event)">
                                    <span class="checkmark" style="margin-top: 13px;"></span>
                                </label>
                                <p class=" pt-3 text-select justify-content-end">select all</p>

                                <div class="list-option " (clickOutside)="onClickedOutside($event)"
                                    [autoClose]="'outside'" [ngbPopover]="popContent" triggers="manual" #p2="ngbPopover"
                                    (click)="$event.stopPropagation();openPopover(p2,0)" placement="bottom">
                                    <div class="dot"></div>
                                    <div class="dot"></div>
                                    <div class="dot"></div>
                                    <ng-template #popContent>
                                        <div>
                                            <div class="popover-content" style="cursor: pointer;"
                                                (click)="cancelBooking();openPopover(p2,0)">
                                                Cancel Booking</div>
                                        </div>
                                    </ng-template>
                                </div>
                            </div>
                        </div> -->

                        <div class="list-container mb-2 pb-4"
                            *ngFor="let list of FacilityBookedDetails | filter:searchText | paginate: {itemsPerPage: pageSize, currentPage: pageNo, totalItems:totalCountList};let i=index">
                            <div class="row">

                                <!-- <div class="col-1" style="padding-left: 3%;">
                                    <label class="check-container" *ngIf="compareDate(list?.startDateTime)">
                                        <input type="checkbox"
                                            (change)="toggleSelection($event,list?.facilityCalendarId)"
                                            [value]="multiSelectBookingId?.includes(list?.facilityCalendarId)"
                                            [checked]="multiSelectBookingId?.includes(list?.facilityCalendarId)">
                                        <span class="checkmark" style="margin-top: 13px;"></span>
                                    </label>
                                </div> -->


                                <div class="col-10">
                                    <div class="row">
                                        <div class="col-12 name">
                                            {{list?.userName}}
                                        </div>
                                    </div>
                                    <div class="row mt-2">
                                        <div class="col-12 detail">
                                            <span style="margin-right: 2.5rem;">{{formatDate(list?.startDateTime)}}-{{formatDate(list?.endDateTime)}}</span>
                                            <span style="margin-right: 2.5rem;">{{formatTime(list?.startDateTime)}}-{{formatTime(list?.endDateTime)}}</span>
                                            <span style="margin-right: 2.5rem;">{{list?.duration}}-{{list?.durationType}}</span>
                                            <span style="margin-right: 2.5rem;">Purpose - {{list?.purpose || 'NA'}}</span>
                                            <span>Remarks - {{list?.remarks || 'NA'}}</span>
                                        </div>
                                    </div>
                                </div>

                                <!-- <div class="col-1" *ngIf="!(BookStatusValue==true&&compareDate(list?.startDate))"></div> -->

                                <div class="col-2 pt-3"
                                    *ngIf="BookingStatusTextTemp=='Confirmed' || BookingStatusTextTemp=='Confirm'">
                                    <div class="list-option" (clickOutside)="onClickedOutside($event)"
                                        *ngIf="compareDate(list?.startDateTime)" [autoClose]="'outside'"
                                        [ngbPopover]="popContent1" triggers="manual" #p1="ngbPopover"
                                        (click)="$event.stopPropagation();openPopover(p1,list?.facilityCalendarId)"
                                        placement="bottom">
                                        <div class="dot"></div>
                                        <div class="dot"></div>
                                        <div class="dot"></div>
                                        <ng-template #popContent1>
                                            <div>
                                                <div class="popover-content"
                                                    (click)="$event.stopPropagation();cancelFacilityBooking(list?.facilityCalendarId);openPopover(p1,list?.facilityCalendarId)"
                                                    style="cursor: pointer;">Cancel Blocking
                                                </div>
                                            </div>
                                            <div>
                                                <div class="popover-content"
                                                    (click)="$event.stopPropagation();editBlocking(list?.facilityCalendarId, list?.startDateTime, list?.endDateTime, list?.purpose, list?.remarks, list?.bookingType, list?.userId, list?.facilityCalendarId);openPopover(p1,list?.facilityCalendarId)"
                                                    style="cursor: pointer;">Edit Blocking
                                                </div>
                                            </div>
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- <div class="d-flex pagination-section mt-4 mb-5" *ngIf="totalCountList > 2">
                    <div class="row d-flex pagination-border">
                        <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChange($event)"
                            nextLabel="" class="d-flex justify-content-center">
                        </pagination-controls>
                        <div class="pr-3 ratio-class pt-1">
                            {{pageNo}}/{{fetchPage(totalCountList)}}</div>
                    </div>
                </div> -->

                <div class="d-flex justify-content-center pagination-section" *ngIf="totalCountList > 10">
                    <div class="row d-flex pagination-border">
                        <pagination-controls class="pagination" previousLabel="" (pageChange)="handlePageChange($event)"
                            nextLabel="" class="d-flex justify-content-center">
                        </pagination-controls>
                        <!-- <div class="pr-3 ratio-class pt-1" *ngIf="creditPoint?.length>=10">10/{{creditPoints?.length}}</div> -->
                        <div class="pr-3 ratio-class pt-1">
                            {{pageNo}}/{{fetchPage(totalCountList)}}</div>
                    </div>
                </div>
            </div>
        </div>